<template>
<div>
    <md-dialog-confirm
        :md-title="confirmPromote.title"
        :md-content-html="confirmPromote.content"
        :md-ok-text="confirmPromote.ok"
        :md-cancel-text="confirmPromote.cancel"
        @close="promoteVersionConfirm"
        ref="promoteVersionDialog">
    </md-dialog-confirm>
    <md-dialog-confirm
        :md-title="confirmDelete.title"
        :md-content-html="confirmDelete.content"
        :md-ok-text="confirmDelete.ok"
        :md-cancel-text="confirmDelete.cancel"
        @close="deleteVersionConfirm"
        ref="deleteVersionDialog">
    </md-dialog-confirm>
    <md-sidenav class="md-left" ref="versionsNav">
        <md-toolbar class="md-dense main-toolbar">
            <md-button class="md-icon-button" @click="back()">
                <md-icon>menu</md-icon>
            </md-button>
            <h3 class="md-title">History</h3>
        </md-toolbar>
        <form novalidate @submit.stop.prevent="saveVersion" v-if="user.active_pay">
            <md-input-container>
                <label>Version Name</label>
                <md-input required v-model="versionTitle"></md-input>
            </md-input-container>
            <md-button class="md-raised md-primary" @click="saveVersion">Save New Version</md-button>
        </form>

        <md-list class="ql-version-list md-double-line">
            <md-list-item>
                <div class="md-list-text-container">
                    <span>Current Version</span>
                    <span v-if="!currentVersion">Live Edit</span>
                    <span v-else>{{currentVersion.name}}</span>
                </div>
            </md-list-item>
            <md-list-item>
                <md-icon v-if="!currentVersion">label</md-icon>
                <md-icon v-else>label_outline</md-icon>
                <div class="md-list-text-container">
                    <span>Live Version</span>
                </div>
                <md-button class="md-icon-button md-list-action" @click="setActiveVersion(null)">
                    <md-icon>launch</md-icon>
                    <md-tooltip md-direction="top">Show Version</md-tooltip>
                </md-button>
            </md-list-item>
            <md-list>
                <md-list-item v-for="(filteredVersions, day) in days" :key="day" md-expand-multiple>
                    <span><strong>{{day}}</strong></span>
                    <md-list-expand>
                        <md-list>
                            <version-element v-for="version in filteredVersions" :key="version.id" 
                                :project="project" 
                                :version="version"
                                @promoteVersion="promoteVersion"
                                @deleteVersion="deleteVersion">
                            </version-element>
                        </md-list>
                    </md-list-expand>
                </md-list-item>
            </md-list>
        </md-list>
    </md-sidenav>
    <!-- <revisions-nav ref="revisionsNav" :project="project" :version="revisionVersion" v-on:back="doneWithRevisions"/> -->
</div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

import NavBus from '@/buses/nav';
import HistoryRevisionsNav from '@/components/history/revisions-nav';
import VersionElement from '@/components/history/version';

const VersionsNav = {
    name: 'VersionsNav',
    props: ['project'],
    data: function() {
        return {
            revisionVersion: {},
            showVersion: this.$props.project.showVersion,
            versionTitle: '',
            versionToPromote: null,
            versionToDelete: null,
            confirmPromote: {
                title: 'Confirm Live Version Replacement',
                ok: 'yes',
                cancel: 'cancel',
                content: 'You are about to make a previous version live. This will immediately record over your current live version. Are you sure you want to replace your current live project with this one?  You won\'t be able to undo this change.'
            },
            confirmDelete: {
                title: 'Confirm Delete Version',
                ok: 'yes',
                cancel: 'cancel',
                content: 'You are about to delete an old saved version of this project. You won\'t be able to undo this change.'
            }
        };
    },
    computed: {
        ...mapGetters([
            'user',
            'versions',
            'currentVersion'
        ]),
        days() {
            const days = this.versions.reduce((rv, x) => {
                const day = moment(x.created).format('MM/DD/YYYY');
                (rv[day] = rv[day] || []).push(x);
                return rv;
            }, {});
            const daysOrdered = {};
            Object.keys(days).sort(this.descendingDateComparison).forEach((key) => {
                daysOrdered[key] = days[key].sort((a, b) => {
                    return moment(b.created).diff(moment(a.created));
                });
            });

            return daysOrdered;
        }
    },
    methods: {
        closeVersionsNav() {
            this.$refs.versionsNav.close();
        },
        back() {
            this.closeVersionsNav();
            NavBus.$emit('main-nav.open');
        },
        setActiveVersion(versionID) {
            if (versionID === null) {
                this.$router.replace(`/project/${this.project.id}`);
            }

            const vIndex = this.versions.findIndex(v => v.id === versionID);
            // this.$store.dispatch('useVersion', versionID);
            if (vIndex > -1) {
                this.$router.replace(`/project/${this.project.id}/version/${versionID}/`);
            }
        },
        saveVersion() {
            this.$store.dispatch('createVersion', this.versionTitle);
            this.versionTitle = '';
        },
        promoteVersion(versionID) {
            this.versionToPromote = versionID;
            this.$refs.promoteVersionDialog.open();
        },
        promoteVersionConfirm(type) {
            if (this.versionToPromote === null) return;

            if (type === 'ok') {
                this.$store.dispatch('promoteVersion', this.versionToPromote);
                // this.$store.dispatch('deleteVersion', versionID);
                this.$router.replace(`/project/${this.project.id}`);
            }
        },
        deleteVersion(versionID) {
            this.versionToDelete = versionID;
            this.$refs.deleteVersionDialog.open();
        },
        deleteVersionConfirm(type) {
            if (this.versionToDelete === null) return;

            if (type === 'ok') {
                this.$store.dispatch('deleteVersion', this.versionToDelete);
            }
        },
        getFormattedDate(version) {
            return moment(version.created).format('MM/DD/YYYY hh:mm:ss a');
        },
        descendingDateComparison(a, b) {
            return moment(b, 'MM/DD/YYYY').diff(moment(a, 'MM/DD/YYYY'));
        }
    },
    created: function() {
        NavBus.$on('versions-nav.open', () => {
            if (this.$refs.versionsNav) {
                this.$refs.versionsNav.open();
            }
        });
    },
    components: {
        'revisions-nav': HistoryRevisionsNav,
        'version-element': VersionElement
    }
};
export default VersionsNav;

</script>

<style lang="scss">
.ql-version-list {
    .md-list-item {
        margin-top: .75em;
        line-height: 40px;
        .md-list-item-container > .md-icon:first-child  {
            margin-right: .5em !important;
        }
        .md-list-item-container > .md-button:first-child {
            margin-left: 0 !important;
        } 
    }
}
.md-sidenav-content > form {
    padding-left: .5em;
}
</style>


// WEBPACK FOOTER //
// versions-nav.vue?974e8d6c